import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import {
  AsReportedIssuerService,
  IssuerMappingService,
} from "src/api/services";
import { sanitizeForm } from "../../../../../core/utils/form-clean";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";
type FormData = {
  cikNumber: string;
  ein: string;
  fileNumber: string;
  fiscalYearEnd: string;
  irsNumber: string;
  issuerId: number | undefined;
  issuerName: string;
  reason: string;
  sicNumber: string;
  totalCount: number | undefined;
};

// Only string keys of formData
type StringFormDataKeys = {
  [K in keyof FormData]: FormData[K] extends string ? K : never;
}[keyof FormData];
type PasteField = StringFormDataKeys | keyof EditMapDataComponent;
@Component({
  selector: "app-edit-data",
  // imports: [],
  templateUrl: "./edit-data.component.html",
  styleUrl: "./edit-data.component.css",
  standalone: false,
})
export class EditMapDataComponent implements OnInit {
  formData = {
    cikNumber: "",
    ein: "",
    fileNumber: "",
    fiscalYearEnd: "",
    irsNumber: "",
    issuerId: undefined as number | undefined,
    issuerName: "",
    reason: "",
    sicNumber: "",
    totalCount: undefined as number | undefined,
  };
  searchIssuer: string = "";
  isLoading: boolean = false;
  filteredIssuers: any[] = [];
  showDropdown = false;
  selectedIssuer: any = null;
  issuerData: any = null;
  validationErrors = {
    issuerName: "",
    cikNumber: "",
  };

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private _issuerMappingService: IssuerMappingService,
    public dialogService: DialogService,
    private _messageService: MessageService,
    private _asReportedIssuerService: AsReportedIssuerService
  ) {}

  ngOnInit(): void {
    if (this.config.data && this.config.data.issuerData) {
      this.issuerData = { ...this.config.data.issuerData };
      this.bindFormData(this.config.data.issuerData);
    }
  }
  private bindFormData(product: any) {
    this.formData = {
      issuerId: product.issuerId || "",
      cikNumber: product.asReportedCik || product.cikNumber || "",
      ein: product.asReportedEin || product.ein || "",
      sicNumber: product.asReportedSic || product.sicNumber || "",
      fileNumber: product.asReportedFileNumber || product.fileNumber || "",
      fiscalYearEnd:
        product.asReportedFiscalYearEnd || product.fiscalYearEnd || "",
      issuerName: product.asReportedIssuerName || product.issuerName || "",
      reason: product.reason || "",
      irsNumber: product.irsNumber || "",
      totalCount: product.totalCount || undefined,
    };
    // Clear validation errors when form data is bound
    this.validationErrors = {
      issuerName: "",
      cikNumber: "",
    };
  }
  onUpdate() {
    // Reset validation errors
    this.validationErrors = {
      issuerName: "",
      cikNumber: "",
    };

    // Validate required fields
    let isValid = true;
    if (!this.formData.issuerName || !this.formData.issuerName.trim()) {
      this.validationErrors.issuerName = "Issuer Name is required";
      isValid = false;
    }
    if (!this.formData.cikNumber || !this.formData.cikNumber.trim()) {
      this.validationErrors.cikNumber = "CIK is required";
      isValid = false;
    }

    if (!isValid) {
      return;
    }
    const payload = {
      ...this.formData,

  cikNumber: this.formData.cikNumber.trim(),
  ein: this.formData.ein.trim(),
  fileNumber: this.formData.fileNumber.trim(),
  fiscalYearEnd: this.formData.fiscalYearEnd.trim(),
  issuerName: this.formData.issuerName.trim(),
  sicNumber: this.formData.sicNumber.trim(),
  reason: "Updated attributes successfully",
  irsNumber: "12345678",

  issuerId: this.issuerData.issuerId,
  totalCount: this.issuerData.totalCount,
    };
    const cleanedForm = sanitizeForm(payload);
    this.isLoading = true;
    this._issuerMappingService.updateIssuer(cleanedForm).subscribe({
      next: (updatedIssuer) => {
        this._messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Issuer updated successfully.",
        });
      },
      error: (error) => {
        this.isLoading = false;
        this._messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Failed to update issuer.",
        });
      },
      complete: () => {
        this.isLoading = false;
        this.ref.close({ refresh: true });
      },
    });
  }

  onCancel() {
    this.ref.close();
  }
  onSearchEnter() {
    const query = this.searchIssuer.trim();
    if (query) {
      this.isLoading = true;
      this._asReportedIssuerService.getAsReportedIssuerByName(query).subscribe({
        next: (data) => {
          this.filteredIssuers = data;
          this.showDropdown = data.length > 0;
        },
        error: (err) => {
          this.isLoading = false;
          this._messageService.add({
            severity: "error",
            summary: err.error?.message || "Failed to fetch insiders",
          });
          this.showDropdown = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    }
  }

  onIssuerSelect(issuer: any) {
    this.selectedIssuer = issuer;
    this.searchIssuer = issuer.asReportedIssuerName || "";
    this.showDropdown = false;
    this.bindFormData(issuer);

    //
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }
  // One universal paste handler for ALL fields
  onPaste(event: ClipboardEvent, field: PasteField): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      if (field in this.formData) {
        // @ts-ignore
        this.formData[field as StringFormDataKeys] = newValue;
      } else {
        // @ts-ignore
        (this as any)[field] = newValue;
      }
    });
  }
}
